"use client"

import { ListIndentDecrease } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ListIndentDecreaseIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ListIndentDecreaseIcon = component(Icon)({
  as: ListIndentDecrease,
})
